<template>
  <div>
    <div class="columns pageContent">
      <div class="column column-menu">
        <div class="box box-menu is-paddingless">
          <aside class="menu-page menu">
            <ul class="menu-list">
              <li>
                <a
                  @click="setActiveMenu('languages')"
                  :class="{ 'is-active': activeMenu === 'languages' }"
                >Languages</a>
              </li>
              <li>
                <a
                  @click="setActiveMenu('mailtexts')"
                  :class="{ 'is-active': activeMenu === 'mailtexts' }"
                >Mail texts</a>
              </li>
              <li>
                <a
                  @click="setActiveMenu('BookingTerm')"
                  :class="{ 'is-active': activeMenu === 'BookingTerm' }"
                >Booking terms</a>
              </li>

              <li>
                <a
                  @click="setActiveMenu('PrivacyPolicy')"
                  :class="{ 'is-active': activeMenu === 'PrivacyPolicy' }"
                >Privacy terms</a>
              </li>

              <li>
                <a
                  @click="setActiveMenu('ReminderMails')"
                  :class="{ 'is-active': activeMenu === 'ReminderMails' }"
                >Reminder mails</a>
              </li>

              <li>
                <a
                  @click="setActiveMenu('PriceTypes')"
                  :class="{ 'is-active': activeMenu === 'PriceTypes' }"
                >Price types</a>
              </li>
            </ul>
          </aside>
        </div>
      </div>
      <div class="column column-content">
        <div class="container">
          <ChannelLanguages v-if="activeMenu === 'languages'" />

          <MailTexts v-if="activeMenu === 'mailtexts'" />

          <PriceTypes v-if="activeMenu === 'PriceTypes'" />

          <Terms
            v-if="activeMenu === 'BookingTerm'"
            :termsType="'BookingTerm'"
            :key="'bookingTerms'"
          />

          <Terms
            v-if="activeMenu === 'PrivacyPolicy'"
            :termsType="'PrivacyPolicy'"
            :key="'privacyTerms'"
          />

          <ReminderMails
            v-if="activeMenu === 'ReminderMails'"
            :key="'reminderMails'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ReminderMails from '../Settings/ReminderMails.vue';

export default {
  components: {
    ChannelLanguages: () => import('@/components/Settings/ChannelLanguages'),
    MailTexts: () => import('@/components/Settings/MailTexts'),
    PriceTypes: () => import('@/components/Settings/PriceTypes'),
    ReminderMails: () => import('@/components/Settings/ReminderMails'),
    Terms: () => import('@/views/Terms/Terms'),
  },

  props: {},

  data() {
    return {
      activeMenu: 'languages',
    }
  },

  computed: {},

  created() { },

  methods: {
    setActiveMenu(item) {
      this.activeMenu = item
    },
  },
}
</script>

<style lang="scss" scoped>
.pageContent {
  .column-menu {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 210px;
  }
  .column-content {
    flex-grow: 1;
  }

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    .column {
      flex-basis: unset;
      flex-basis: unset;
    }
  }
}
</style>>
